<!--
 * @Author: chenxing
 * @Date: 2021-04-23 09:43:20
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-08-25 16:24:34
-->
<template>
  <div class="today_actor w100 h100">
    <a-row class="filter_row">
      <a-col :span="1" style="line-height: 40px">筛选：</a-col>
      <a-col :span="6">
        <a-form-item :wrapper-col="{ span: 22 }">
          <a-range-picker v-model:value="filterCondition.defaultValue" :placeholder="['开始日期', '结束日期']" separator="至" :format="['YYYY-MM-DD', 'YYYY-MM-DD']" @change="onDateRangeChange" :allow-clear="false" />
        </a-form-item>
      </a-col>
      <a-col :span="17">
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-space class="float-r">
            <a-button type="primary" @click="onFilterTodayActorBtnClick" :disabled="showTableLoading">筛选</a-button>
            <a-button type="default" @click="onResetFilterBtnClick" :disabled="showTableLoading">重置</a-button>
          </a-space>
        </a-form-item>
      </a-col>
    </a-row>
    <div class="table_wrapper bcg_w">
      <a-row style="margin-bottom: 12px" v-hasPermission="`TODAYACTOR_ADD`">
        <a-button type="primary" @click="onActorInputBtnClick" :disabled="showTableLoading"><PlusCircleOutlined style="font-size: 14px" />当日演员录入</a-button>
      </a-row>
      <a-table size="small" :loading="showTableLoading" table-layout="fixed" :data-source="todayActorTableList" :scroll="{ x: true, y: tableHeight }" :columns="todayActorTableColumns" :pagination="todayActorTablePagination" bordered :row-key="record => record.deptId + record.actTime" @change="changePagination">
        <template #operation="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            <a v-hasPermission="`TODAYACTOR_EDIT`" @click="onTodayOneActorEditClick(item, record.deptId)">编辑</a>
          </div>
        </template>
        <template #actorName="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box" style="min-width: 3.1rem">
            {{ item.actorName }}
          </div>
        </template>
        <template #actType="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ columnMap(todayType, item.type) }}
          </div>
        </template>
        <template #actorCost="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.cost }}
          </div>
        </template>
        <template #mouthPlayActNum="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.mouthPlayActNum }}
          </div>
        </template>
        <template #mouthPlayAverageCost="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.mouthPlayAverageCost }}
          </div>
        </template>
        <template #noMouthPlayActNum="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.noMouthPlayActNum }}
          </div>
        </template>
        <template #noMouthPlayAverageCost="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.noMouthPlayAverageCost }}
          </div>
        </template>
        <template #actorNumber="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.actNum }}
          </div>
        </template>
        <template #actorAverageCost="{ record }">
          <div v-for="(item, index) in record.actorInfoList" :key="index" class="table-arr-box">
            {{ item.averageCost }}
          </div>
        </template>
      </a-table>
    </div>

    <a-modal class="actor_info_modal" v-model:visible="InputActorModalVisible" :title="todayActorModalTitle" @ok="sumbitTodayActorModalData" cancel-text="取消" ok-text="确认" :width="600" @cancel="cancelSumbitTodayActorModalData" :mask-closable="false">
      <a-spin :spinning="saving">
        <a-form ref="inputActorForm" :model="todayActorModalData" :rules="todayActorModalFormRules" :label-col="{ xs: { span: 6 }, sm: { span: 4 } }" :wrapper-col="{ xs: { span: 18 }, sm: { span: 20 } }">
          <a-form-item label="演员姓名" name="actorName">
            <a-auto-complete v-model:value="todayActorModalData.actorName" placeholder="请选择演员" :options="actorTodaySearchList" :disabled="actEditDisable" @search="actorTodaySearch"> </a-auto-complete>
          </a-form-item>
          <a-form-item label="邀请组" name="deptId">
            <a-tree-select
              v-model:value="todayActorModalData.deptId"
              placeholder="请选择邀请组"
              :tree-data="projectListTreeOptions"
              :field-names="{ label: 'label', value: 'value', children: 'children' }"
              tree-default-expand-all
              show-search
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              tree-node-filter-prop="title"
            >
            </a-tree-select>
          </a-form-item>
          <a-form-item label="参演天数" name="type">
            <a-select v-model:value="todayActorModalData.type" placeholder="请选择参演天数">
              <a-select-option :value="item.value" v-for="(item, index) in todayType" :key="index">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="参演日期" name="actTime">
            <a-date-picker class="blue-icon" :disabled="actEditDisable" style="width: 100%" placeholder="请选择参演日期" :format="['YYYY-MM-DD']" v-model:value="todayActorModalData.actTime" :allow-clear="false" />
          </a-form-item>
          <a-form-item label="演员花费" name="cost">
            <a-input v-model:value="todayActorModalData.cost" placeholder="请输入今日演员价格" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import langCh from 'ant-design-vue/es/locale/zh_CN';
import { getActorTimePageData, saveOneActorData, updateActorData, getActorListData, getActorDeptListData, saveCreateActorData } from '@/api/actor/todayActor.js';
import { getDeptListDataByType } from '@/api/base/department.js';
import { getDocumentScroll } from '@/utils/utils.js';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

export default {
  components: { PlusCircleOutlined },
  data() {
    return {
      locale: langCh,
      tableHeight: 1920,
      InputActorModalVisible: false, //演员录入会话框显示
      todayActorModalTitle: '',
      actEditDisable: false,
      showTableLoading: false, //表格加载
      saving: false, // 保存中
      filterCondition: {
        defaultValue: [moment(), moment()],
      }, //筛选条件数据对象
      projectListOptions: [],
      projectListTreeOptions: [],
      todayActorModalData: {}, //当日演员会话框数据对象
      actorTodayInputList: [], //会话框今日演员录入演员数据
      actorTodaySearchList: [], // 会话框今日演员搜索数据
      todayActorTableList: [],
      todayActorTableColumns: [
        {
          title: '邀请组',
          dataIndex: 'deptName',
          align: 'center',
          key: 'deptName',
        },
        {
          title: '参演日期',
          dataIndex: 'actTime',
          align: 'center',
          width: 90,
          key: 'actTime',
        },
        {
          title: '演员姓名',
          width: 90,
          dataIndex: 'actorName',
          align: 'center',
          key: 'actorName',
          slots: {
            customRender: 'actorName',
          },
        },
        {
          title: '全/半天',
          dataIndex: 'type',
          width: 80,
          align: 'center',
          key: 'type',
          slots: {
            customRender: 'actType',
          },
        },
        {
          title: '演员花费(元)',
          dataIndex: 'cost',
          width: 100,
          align: 'center',
          key: 'cost',
          slots: {
            customRender: 'actorCost',
          },
        },
        {
          title: '口播条数',
          dataIndex: 'mouthPlayActNum',
          key: 'mouthPlayActNum',
          align: 'center',
          width: 80,
          slots: {
            customRender: 'mouthPlayActNum',
          },
        },
        {
          title: '口播均价(元/条)',
          dataIndex: 'mouthPlayAverageCost',
          key: 'mouthPlayAverageCost',
          align: 'center',
          width: 120,
          slots: {
            customRender: 'mouthPlayAverageCost',
          },
        },
        {
          title: '非口播条数',
          dataIndex: 'noMouthPlayActNum',
          key: 'noMouthPlayActNum',
          align: 'center',
          width: 90,
          slots: {
            customRender: 'noMouthPlayActNum',
          },
        },
        {
          title: '非口播均价(元/条)',
          dataIndex: 'noMouthPlayAverageCost',
          key: 'noMouthPlayAverageCost',
          width: 140,
          align: 'center',
          slots: {
            customRender: 'noMouthPlayAverageCost',
          },
        },
        {
          title: '参演条数',
          dataIndex: 'actNum',
          key: 'actNum',
          align: 'center',
          width: 80,
          slots: {
            customRender: 'actorNumber',
          },
        },
        {
          title: '均价(元/条)',
          dataIndex: 'averageCost',
          key: 'averageCost',
          width: 100,
          align: 'center',
          slots: {
            customRender: 'actorAverageCost',
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 80,
          slots: {
            customRender: 'operation',
          },
        },
      ],
      todayActorTablePagination: {
        page: '1',
        limit: 30,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
      todayActorModalFormRules: {
        actorName: [{ required: true, message: '请输入演员姓名', trigger: 'blur' }],
        deptId: [{ required: true, message: '请选择邀请组', trigger: 'blur' }],
        type: [{ required: true, message: '请选择演员参演天数', trigger: 'blur' }],
        actTime: [{ type: 'object', required: true, message: '请选择参演日期', trigger: 'blur' }],
        cost: [
          {
            required: true,
            validator: function validateCost(rule, value) {
              if (!value) {
                return Promise.reject('请输入演员花费');
              } else if (value < 0) {
                return Promise.reject('请输入正数！');
              } else {
                return Promise.resolve();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      todayType: [
        { value: 'ALL', label: '全天' },
        { value: 'AM', label: '上午' },
        { value: 'PM', label: '下午' },
      ],
    };
  },
  created() {
    this.getTodayActorList();
    this.getProjectListByType();
    this.getActorList();
  },
  watch: {
    tableHeight(newVal) {
      this.tableHeight = newVal;
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableHeight = getDocumentScroll();
      })();
    };
  },
  methods: {
    columnMap(options, key) {
      return options.filter(item => {
        return item.value == key;
      })[0].label;
    },
    weekData(s) {
      if (s) {
        return '星期' + '日一二三四五六'.charAt(new Date(s).getDay());
      }
    },
    async getProjectListByType() {
      let res = await getDeptListDataByType({});
      // 只保留VIDEO类型的选项到projectListOptions
      this.projectListOptions = res.list.filter(d => d.deptType === 'VIDEO').map(d => {
        return { label: d.name, value: d.deptId };
      });
      
      // 转换为树形结构
      this.projectListTreeOptions = this.convertToTree(res.list);
    },
    
    // 将扁平的部门数据转换为树形结构
    convertToTree(list) {
      if (!list || !Array.isArray(list)) {
        return [];
      }
      
      // 创建一个映射，便于查找部门
      const deptMap = {};
      
      // 首先创建所有部门的映射
      list.forEach(item => {
        deptMap[item.deptId] = {
          value: item.deptId,
          label: item.name,
          deptType: item.deptType, // 保留原始数据中的deptType
          selectable: item.deptType === 'VIDEO', // 只有VIDEO类型的部门可选择
          disabled: item.deptType !== 'VIDEO', // 非VIDEO类型的部门置灰
          children: []
        };
      });
      
      // 构建树形结构
      list.forEach(item => {
        const node = deptMap[item.deptId];
        
        // 如果有父部门且父部门存在于列表中
        if (item.parentId && deptMap[item.parentId]) {
          // 添加到父节点的children中
          deptMap[item.parentId].children.push(node);
        }
      });
      
      // 递归检查节点是否包含VIDEO类型的子节点
      const hasVideoDescendant = (node) => {
        if (node.deptType === 'VIDEO') {
          return true;
        }
        if (node.children && node.children.length > 0) {
          return node.children.some(child => hasVideoDescendant(child));
        }
        return false;
      };
      
      // 递归过滤节点
      const filterTree = (nodes) => {
        return nodes
          .filter(node => hasVideoDescendant(node)) // 只保留有VIDEO类型后代的节点
          .map(node => {
            return {
              ...node,
              children: filterTree(node.children) // 递归过滤子节点
            };
          });
      };
      
      // 获取所有根节点并过滤
      const roots = [];
      list.forEach(item => {
        if (!item.parentId || !deptMap[item.parentId]) {
          roots.push(deptMap[item.deptId]);
        }
      });
      
      // 过滤树结构
      return filterTree(roots);
    },
    async getActorList() {
      let res = await getActorListData({});
      res.list.forEach(item => {
        item.value = item.actorName;
        item.key = item.id;
        item.text = item.actorName;
      });
      this.actorTodayInputList = res.list;
      this.actorTodaySearchList = res.list;
    },
    async getTodayActorList() {
      if (this.showTableLoading === true) {
        return;
      }
      this.showTableLoading = true;
      let postParams = {
        startActTime: moment().format('YYYY-MM-DD'),
        endActTime: moment().format('YYYY-MM-DD'),
        ...this.todayActorTablePagination,
        ...this.filterCondition,
      };

      let res = await getActorTimePageData(postParams);
      this.todayActorTableList = res.page.list;
      this.todayActorTablePagination.total = res.page.totalCount;
      this.todayActorTablePagination.current = res.page.currPage;
      this.todayActorTablePagination.pageSize = res.page.pageSize;
      this.showTableLoading = false;
      this.tableHeight = getDocumentScroll();
    },
    onTodayOneActorEditClick(item, deptId) {
      this.actEditDisable = true;
      this.todayActorModalTitle = '当日演员编辑';
      this.todayActorModalData = {
        ...item,
        cost: item.cost.toString(),
        actTime: moment(item.actTime),
        deptId: deptId,
      };

      this.InputActorModalVisible = true;
    },
    /** 邀请组下拉框选择
     * @param {*}
     * @return {*}
     */
    onDeptNameChange() {
      this.getTodayActorList();
    },
    // 开始时间结束时间选择
    onDateRangeChange(val, dateString) {
      this.filterCondition.startActTime = dateString[0];
      this.filterCondition.endActTime = dateString[1];
      // this.getTodayActorList();
    },
    //当日演员录入会话框显示
    onActorInputBtnClick() {
      this.actEditDisable = false;
      this.todayActorModalTitle = '当日演员录入';
      this.todayActorModalData = {
        actTime: moment(),
        actorName: '',
      };
      this.InputActorModalVisible = true;
    },
    async sumbitTodayActorModalData() {
      await this.$refs.inputActorForm.validate();
      this.saving = true;
      if (this.todayActorModalData.createActor) {
        let postData = {
          actorName: this.todayActorModalData.createActorName,
        };
        let createActorRes = await saveCreateActorData(postData);
        if (createActorRes.code === 0) {
          this.todayActorModalData.actorId = createActorRes.id;
          this.getActorList();
        } else {
          this.saving = false;
          return;
        }
      }

      let postParams = {
        ...this.todayActorModalData,
        actTime: this.todayActorModalData.actTime.format('YYYY-MM-DD'),
      };
      await this.$refs.inputActorForm.validate();
      if (postParams.id) {
        let res = await updateActorData(postParams);
        if (res.code == 0) {
          this.$message.success('修改成功');
          this.InputActorModalVisible = false;
          this.getTodayActorList();
        }
      } else {
        let res = await saveOneActorData(postParams);
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.InputActorModalVisible = false;
          this.getTodayActorList();
        }
      }

      this.saving = false;
    },
    cancelSumbitTodayActorModalData() {
      this.$refs.inputActorForm.resetFields();
    },
    //按条件筛选
    onFilterTodayActorBtnClick() {
      this.todayActorTablePagination.page = '1';
      this.getTodayActorList();
    },
    // 重置筛选
    onResetFilterBtnClick() {
      this.filterCondition = {};
      this.todayActorTablePagination.page = '1';
      this.getTodayActorList();
      this.filterCondition = { defaultValue: [moment(), moment()] };
    },
    //分页功能
    changePagination(pagination) {
      this.todayActorTablePagination.page = pagination.current.toString();
      this.todayActorTablePagination.limit = pagination.pageSize.toString();
      this.getTodayActorList();
    },
    /** 搜索下拉列表的值
     * @param {*} value 输入的值
     * @return {*}
     */
    actorTodaySearch(value) {
      this.actorTodaySearchList = [];
      this.actorTodayInputList.forEach(item => {
        if (item.actorName && item.actorName.indexOf(value) !== -1) {
          this.actorTodaySearchList.push(item);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.today_actor {
  display: flex;
  flex-direction: column;
}
.table-arr-box {
  margin: -8px;
  padding: 4px;
  margin-top: 8px;
}
.table-arr-box:first-child {
  margin-top: -8px;
}
.table-arr-box + .table-arr-box {
  border-top: 1px solid #f0f0f0;
}
</style>
<style lang="less">
.actor_info_modal {
  .ant-form-item-label {
    line-height: 40px;
  }
}
</style>